"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _classCallCheck = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractionManager = void 0;

var Grabber_1 = require("./Interactions/Mouse/Grabber");

var Repulser_1 = require("./Interactions/Mouse/Repulser");

var Bubbler_1 = require("./Interactions/Mouse/Bubbler");

var Connector_1 = require("./Interactions/Mouse/Connector");

var Linker_1 = require("./Interactions/Particles/Linker");

var Attractor_1 = require("./Interactions/Particles/Attractor");

var Collider_1 = require("./Interactions/Particles/Collider");

var Infecter_1 = require("./Interactions/Particles/Infecter");

var TrailMaker_1 = require("./Interactions/Mouse/TrailMaker");

var Attractor_2 = require("./Interactions/Mouse/Attractor");

var InteractionManager =
/*#__PURE__*/
function () {
  function InteractionManager(container) {
    _classCallCheck(this, InteractionManager);

    this.container = container;
    this.externalInteractors = [new Attractor_2.Attractor(container), new Bubbler_1.Bubbler(container), new Connector_1.Connector(container), new Grabber_1.Grabber(container), new Repulser_1.Repulser(container), new TrailMaker_1.TrailMaker(container)];
    this.particleInteractors = [new Attractor_1.Attractor(container), new Collider_1.Collider(container), new Infecter_1.Infecter(container), new Linker_1.Linker(container)];
  }

  _createClass(InteractionManager, [{
    key: "init",
    value: function init() {}
  }, {
    key: "externalInteract",
    value: function externalInteract(delta) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.externalInteractors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var interactor = _step.value;

          if (interactor.isEnabled()) {
            interactor.interact(delta);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "particlesInteract",
    value: function particlesInteract(particle, delta) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.externalInteractors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var interactor = _step2.value;
          interactor.reset(particle);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.particleInteractors[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _interactor = _step3.value;

          if (_interactor.isEnabled(particle)) {
            _interactor.interact(particle, delta);
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }]);

  return InteractionManager;
}();

exports.InteractionManager = InteractionManager;